module.exports = __webpack_public_path__ + "img/tz.70dd4d9b.svg";